import useModal from 'hooks/useModal'
import { useCallback, useMemo } from 'react'
import GameFilterModal, { GameFilterModalProps } from '../components/GameFilterModal'

export const useOpenGameFilterModal = () => {
  const [onPresent, onDismiss] = useModal<GameFilterModalProps>(GameFilterModal)

  const handlePresentGameFilterModal = useCallback(
    (props: GameFilterModalProps) => {
      onPresent(props)
    },
    [onPresent],
  )

  return useMemo(() => ({ handlePresentGameFilterModal, onDismiss }), [handlePresentGameFilterModal, onDismiss])
}
